// import React from 'react';
// import { Layout } from 'antd';
// import MainSection from './MainSection';
// import FourstepSection from './FourSteps';
// import MakeEasier from './MakeEasier';
// import Questions from './Questions';
// import WorkInTeam from './WorkInTeam';
// import PriceList from './PriceList';
// import Udobno from './Udobno';
// import Header from './Header';
// import ContactBlock from './ContactBlock';

// import Footer from './Footer';

// const { Content } = Layout;

// const CustomLayout = () => (
//   <Layout
//     className="layout"
//   >
//     <Header />
//     <Content style={{ padding: '0 50px', background: '#ffffff' }}>

//       <MainSection />
      
//       <div style={{ background: '#fff', position: 'relative', minHeight: 'calc(100vh - 64px)' }}> {/* Вычитаем высоту header если он есть */}     
//         <div >
//           <Udobno />
          
//           <MakeEasier />

//           <FourstepSection />

//           <WorkInTeam />

//           <PriceList />

//           <Questions />
          
//           <div className='mb-4'><ContactBlock /></div>
          
//         </div>

//       </div>

//     </Content>
    
//     <Footer />
    
//   </Layout>
// );

// export default CustomLayout;


// import React from 'react';
// import { Layout } from 'antd';
// import MainSection from './MainSection';
// import FourstepSection from './FourSteps';
// import MakeEasier from './MakeEasier';
// import Questions from './Questions';
// import WorkInTeam from './WorkInTeam';
// import PriceList from './PriceList';
// import Udobno from './Udobno';
// import Header from './Header';
// import ContactBlock from './ContactBlock';
// import Footer from './Footer';

// const { Content } = Layout;

// const CustomLayout = () => (
//   <Layout className="layout">
//     <Header />
//     <Content style={{ padding: '0 50px', background: '#ffffff' }}>
//       <MainSection />
     
//       <div className="relative w-full"> {/* Убрали ограничение высоты */}    
//         <div>
//           <Udobno />
//           <MakeEasier />
//           <FourstepSection />
//           <WorkInTeam />
//           <PriceList />
//           <Questions />
//           <div className="w-full"><ContactBlock /></div> {/* Изменили mb-4 на w-full */}
//         </div>
//       </div>
//     </Content>
   
//     <Footer />
//   </Layout>
// );

// export default CustomLayout;

import React from 'react';
import { Layout } from 'antd';
import MainSection from './MainSection';
import FourstepSection from './FourSteps';
import MakeEasier from './MakeEasier';
import Questions from './Questions';
import WorkInTeam from './WorkInTeam';
import PriceList from './PriceList';
import Udobno from './Udobno';
import Header from './Header';
import ContactBlock from './ContactBlock';
import Footer from './Footer';

const { Content } = Layout;

const CustomLayout = () => (
  <Layout className="layout" style={{ overflow: 'hidden' }}>
    <Header />
    <Content style={{ background: '#ffffff', position: 'relative' }}>
      <MainSection />
     
      <div className="relative w-full px-4 md:px-12 lg:px-50">
        <div>
          <Udobno />
          <MakeEasier />
          <FourstepSection />
          <WorkInTeam />
          <PriceList />
          <Questions />
          <div className="w-full">
            <ContactBlock />
          </div>
        </div>
      </div>
    </Content>
   
    <Footer />
  </Layout>
);

export default CustomLayout;
